 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import DED from '@/components/ded'
 import EPI from '@/components/epi'
 import CONTENTS from '@/components/contents'
 import ACK from '@/components/ack'
 import TABLEOF from '@/components/tableof'
 import ANOTE from '@/components/anote'
 import INTRO from '@/components/intro'
 import PH01 from '@/components/ph01'
 import THEMYTH from '@/components/themyth'
 import PH02 from '@/components/ph02'
 import CH01 from '@/components/ch01'
 import CH02 from '@/components/ch02'
 import CH03 from '@/components/ch03'
 import CH04 from '@/components/ch04'
 import CH05 from '@/components/ch05'
 import CH06 from '@/components/ch06'
 import PH03 from '@/components/ph03'
 import CH07 from '@/components/ch07'
 import CH08 from '@/components/ch08'
 import CH09 from '@/components/ch09'
 import CH10 from '@/components/ch10'
 import CH11 from '@/components/ch11'
 import CH12 from '@/components/ch12'
 import CH13 from '@/components/ch13'
 import CH14 from '@/components/ch14'
 import PH04 from '@/components/ph04'
 import CH15 from '@/components/ch15'
 import CH16 from '@/components/ch16'
 import CH17 from '@/components/ch17'
 import CH18 from '@/components/ch18'
 import CH19 from '@/components/ch19'
 import CH20 from '@/components/ch20'
 import CH21 from '@/components/ch21'
 import CH22 from '@/components/ch22'
 import CH23 from '@/components/ch23'
 import CH24 from '@/components/ch24'
 import PH05 from '@/components/ph05'
 import CH25 from '@/components/ch25'
 import CH26 from '@/components/ch26'
 import CH27 from '@/components/ch27'
 import CH28 from '@/components/ch28'
 import CH29 from '@/components/ch29'
 import CH30 from '@/components/ch30'
 import CH31 from '@/components/ch31'
 import CH32 from '@/components/ch32'
 import LOVE_2 from '@/components/love_2'
 import APPENDIX from '@/components/appendix'
 import ABBRE from '@/components/abbre'
 import NOTES from '@/components/notes'
 import NOTES1 from '@/components/notes1'
 import SELECT from '@/components/select'
 import INDEX from '@/components/index'
 import CLASSIFIED from '@/components/classified'
 import OPERAS from '@/components/operas'
 import OTHER from '@/components/other'
 import INDEXOF from '@/components/indexof'
 import GENERAL from '@/components/general'
 import ATA from '@/components/ata'
 import REV from '@/components/rev'
 import COPY from '@/components/copy'
 import ATP from '@/components/atp'
 import FOOTNOTE from '@/components/footnote'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/ded",
 			"name" : "ded",
 			"component" : DED
 		},
 		{
 			"path" : "/epi",
 			"name" : "epi",
 			"component" : EPI
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/tableof",
 			"name" : "tableof",
 			"component" : TABLEOF
 		},
 		{
 			"path" : "/anote",
 			"name" : "anote",
 			"component" : ANOTE
 		},
 		{
 			"path" : "/intro",
 			"name" : "intro",
 			"component" : INTRO
 		},
 		{
 			"path" : "/ph01",
 			"name" : "ph01",
 			"component" : PH01
 		},
 		{
 			"path" : "/themyth",
 			"name" : "themyth",
 			"component" : THEMYTH
 		},
 		{
 			"path" : "/ph02",
 			"name" : "ph02",
 			"component" : PH02
 		},
 		{
 			"path" : "/ch01",
 			"name" : "ch01",
 			"component" : CH01
 		},
 		{
 			"path" : "/ch02",
 			"name" : "ch02",
 			"component" : CH02
 		},
 		{
 			"path" : "/ch03",
 			"name" : "ch03",
 			"component" : CH03
 		},
 		{
 			"path" : "/ch04",
 			"name" : "ch04",
 			"component" : CH04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js